import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

const Dashboard = React.lazy(() => import('routes/Dashboard'));
const StaticDashboard = React.lazy(() => import('routes/StaticDashboard'));
const Explorer = React.lazy(() => import('routes/Explorer'));
const CashRecon = React.lazy(() => import('routes/CashRecon'));
const TaRecon = React.lazy(() => import('routes/TaRecon'));
const HoldingRecon = React.lazy(() => import('routes/HoldingRecon'));
const ExplorerAuthorization = React.lazy(() => import('routes/ExplorerAuthorization'));
const EntitlementRoutes = React.lazy(() => import('routes/Entitlement'));
const EventMonitoringDashboard = React.lazy(() => import('screens/Explorer/EventMonitoringExplorer/default'));
const ImportExport = React.lazy(() => import('screens/ImportExport'));
const SupersetAdmin = React.lazy(() => import('screens/SupersetAdmin'));
const Connectors = React.lazy(() => import('screens/Connectors'));
const LinkedData = React.lazy(() => import('screens/CashRecon/CashReconExplorer/LinkedData/index'));
const Unauthorized = React.lazy(() => import('components/NotFoundPage/index'));
const CashReferenceData = React.lazy(() => import('screens/CashRecon/CashReferenceData'));
const ArchiveExplorer = React.lazy(() => import('screens/ArchiveExplorer'));
const SignOffExplorer = React.lazy(() => import('screens/SignOffExplorer'));
const ImportMonitor = React.lazy(() => import('screens/StaticDashboard/ImportMonitoringExplorer'));

const ProtectedRoutes = ({ appRoutes }) => {
    const allowedPaths = appRoutes.map((route) => route.path);
    const routeComponents = {
        '/dashboard': Dashboard,
        '/event-monitoring-explorer': EventMonitoringDashboard,
        '/static': StaticDashboard,
        '/explorer': Explorer,
        '/cash-recon/cash-reference-data-explorer': CashReferenceData,
        '/cash-recon': CashRecon,
        '/holding-recon': HoldingRecon,
        '/entitlement': EntitlementRoutes,
        '/archive': ArchiveExplorer,
        '/signoff': SignOffExplorer,
        '/ta-recon': TaRecon,
        '/import-monitor': ImportMonitor,
        '/import-monitor-core': ImportMonitor,
    };
    return (
        <Switch>
            <Route exact path="/" component={Dashboard} />
            {allowedPaths.map((path) => {
                return <Route key={path} path={path} component={routeComponents[path]} />;
            })}
            <Route path="/superset-admin" component={SupersetAdmin} />
            <Route path="/import-export" component={ImportExport} />
            <Route path="/connectors" component={Connectors} />
            <Route path="/cash-recon" component={CashRecon} />
            <Route path="/linked-data" component={LinkedData} />
            <Route path="/auth" component={ExplorerAuthorization} />
            <Route component={Unauthorized} />
        </Switch>
    );
};

const mapStateToProps = (state) => {
    return {
        appRoutes: state.appConfigurationReducer.appRoutes,
    };
};
export default connect(mapStateToProps)(ProtectedRoutes);
